import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const DepartmentDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Department"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Department">
                {getFieldDecorator('department', {
                 initialValue: data.department,
                  rules: [{ required: true, message: 'Please input the Department!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default DepartmentDialogForm;
